export const ADD_SPRITE_TO_FRAMES: String = 'ADD_SPRITE_TO_FRAMES';
export const ACTIVATE_FRAME: String = 'ACTIVATE_FRAME';
export const SWIPE_FRAME: String = 'SWIPE_FRAME';
export const DELETE_FRAME: String = 'DELETE_FRAME';

// TODO: Reservar la acción reset
export const RESET_ANIMATION: String = 'RESET_ANIMATION';

// #### INTERFACES
// Agregar sprite al frame container
export interface AddSpriteToFramesPayload {
    id: string;
    sprite: {
        id: string;
        local_id: string;
        name: string;
        src: string;
        active: boolean;
    }
}
export interface AddSpriteToFrames {
    type: typeof ADD_SPRITE_TO_FRAMES;
    payload: AddSpriteToFramesPayload 
}

// Swipe
export interface SwipeFramePayload {
    id: string,
    frames: Array<any>
}

export interface SwipeFrame {
    type: typeof SWIPE_FRAME,
    payload: SwipeFramePayload
}

// Activate frame
export interface ActivateFramePayload {
    local_id: string;
}

export interface ActivateFrame {
    type: typeof ACTIVATE_FRAME;
    payload: ActivateFramePayload
}

// Delete Frame
export interface DeleteFramePayload {
    local_id: string;
}
export interface DeleteFrame {
    type: typeof DELETE_FRAME;
    payload: DeleteFramePayload
}

export type FrameListTypes = AddSpriteToFrames & ActivateFrame & DeleteFrame;

// #### ACTIONS

export const AddSpriteToFramesAction = (payload: AddSpriteToFramesPayload): AddSpriteToFrames => {
    return {
        type: ADD_SPRITE_TO_FRAMES,
        payload
    }
}

export const ActivateFrameAction = (payload: ActivateFramePayload): ActivateFrame => {
    return {
        type: ACTIVATE_FRAME,
        payload
    }
}

export const SwipeFrameAction = (payload: SwipeFramePayload): SwipeFrame => {
    return {
        type: SWIPE_FRAME,
        payload
    }
}

export const DeleteFrameAction = (payload: DeleteFramePayload): DeleteFrame => {
    return {
        type: DELETE_FRAME,
        payload
    }
}